import { ContactEntity } from '../contact';
import { Entity } from '../entity';

export enum ConnectJobTrigger {
    Manual = 'Manual',
    Completed = 'Completed',
    Finalised = 'Finalised'
}

export enum ConnectClaimTrigger {
    Manual = 'Manual',
    OnSubmit = 'On Submit',
}

export enum ConnectStatus {
    Disabled = 'Disabled',
    Pending = 'Pending',
    Enabled = 'Enabled'
}

export interface ConnectCustomerSettings {
    account: Entity;
    sendJobCompletion: ConnectJobTrigger;
    sendActivities: ConnectJobTrigger;
    sendClaims: ConnectClaimTrigger;
    token?: string;
    status: ConnectStatus;
}

export interface ConnectContractorSettings {
    account: ContactEntity;
    acceptJobCompletion: boolean;
    acceptActivities: boolean;
    enableClaiming: boolean;
    token?: string;
    status: ConnectStatus;
}

export type ConnectSetting = ConnectCustomerSettings | ConnectContractorSettings;
